module.exports = "/work-site/img/warining_type.f354ca01.png";